import React, { useState, useEffect } from 'react';
import { Twitter, Linkedin, Github, Instagram, Newspaper, Globe2 } from 'lucide-react';
import { useTheme } from '../ThemeContext';
import { useSiteContent } from '../SiteContentContext';

const iconMap = {
  twitter: Twitter,
  linkedin: Linkedin,
  github: Github,
  instagram: Instagram,
  medium: Newspaper,
  crumbles: Globe2,
};

const LiveClock = ({ isDark }) => {
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);
  const formatted = time.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
  return (
    <span className={`font-mono-space text-xs tabular-nums ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>
      IN,IST_{formatted}
    </span>
  );
};

const Footer = () => {
  const { isDark, isDev } = useTheme();
  const { content } = useSiteContent();

  const footer = content.footer || {};
  const socials = (footer.socials || []).filter((item) => iconMap[item.platform]);

  return (
    <footer className="relative bg-transparent">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex flex-col items-center md:items-start gap-2">
            <span className={`text-2xl font-black tracking-tighter ${isDark ? 'text-white' : 'text-gray-900'}`}>
              AS<span className="text-red-600">.</span>
            </span>
            <p className={`text-sm ${isDark ? 'text-gray-500' : 'text-gray-500'}`}>
              {footer.tagline || 'Building things on the internet.'}
            </p>
          </div>

          <div className="flex items-center gap-3">
            {socials.map(({ platform, href }, i) => {
              const Icon = iconMap[platform];
              return (
              <a key={i} href={href} target="_blank" rel="noopener noreferrer" aria-label={`Open ${platform}`} title={platform} className={`w-9 h-9 flex items-center justify-center rounded-full transition-all duration-300 magnetic-hover ${isDark ? 'bg-white/5 text-gray-500 hover:bg-red-600 hover:text-white' : 'bg-gray-100 text-gray-500 hover:bg-gray-900 hover:text-white'}`}>
                <Icon size={15} />
              </a>
            )})}
          </div>
        </div>

        <div className={`mt-8 pt-6 border-t flex flex-col sm:flex-row items-center justify-between gap-3 ${isDev ? 'border-emerald-500/20' : isDark ? 'border-gray-800' : 'border-gray-200'}`}>
          <p className={`text-xs font-mono-space ${isDark ? 'text-gray-600' : 'text-gray-400'}`}>
            &copy; {new Date().getFullYear()} Amandeep Singh
          </p>
          <LiveClock isDark={isDark} />
          <p className={`text-xs flex items-center gap-1 ${isDark ? 'text-gray-600' : 'text-gray-400'}`}>
            Made with curiosity
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
